import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3a0f7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<svg class=\"Border\" fill=\"none\" viewBox=\"0 0 200 200\" data-v-b3a0f7a0><circle cx=\"100\" cy=\"100\" r=\"95.3125\" stroke=\"var(--white)\" stroke-width=\"9.375\" data-v-b3a0f7a0></circle><circle cx=\"100\" cy=\"100\" r=\"95.3125\" stroke=\"url(#UIBtnCamera-gradient)\" stroke-width=\"9.375\" data-v-b3a0f7a0></circle><defs data-v-b3a0f7a0><linearGradient id=\"UIBtnCamera-gradient\" x1=\"32.62\" x2=\"233.51\" y1=\"-58.83\" y2=\"21.69\" gradientUnits=\"userSpaceOnUse\" data-v-b3a0f7a0><stop stop-color=\"#F5AAE0\" data-v-b3a0f7a0></stop><stop offset=\".48\" stop-color=\"#A47CDA\" stop-opacity=\".82\" data-v-b3a0f7a0></stop><stop offset=\"1\" stop-color=\"#4D4BD2\" stop-opacity=\".63\" data-v-b3a0f7a0></stop></linearGradient></defs></svg><span class=\"Background\" data-v-b3a0f7a0></span>", 2)
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Foreground" }, null, -1))
const _hoisted_4 = { class: "Crop" }

import { withDefaults } from 'vue'

interface Props {
  active?: boolean
}


import AudioManager from '@/core/audio/AudioManager'
import { defineComponent } from 'vue'

const __default__ = defineComponent({})

function setup(__props: any) {

const props = __props as { active: boolean }



function onClick(){
  AudioManager.playUI("ui_click");
}

function onMouseEnter(){
  if(!props.active)
    AudioManager.playUI("ui_rollover_camera_enter_snap");
}


return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["UIBtn UIBtnCamera", { 'is-active': __props.active }]),
    onMouseenter: onMouseEnter,
    onClick: onClick
  }, [
    _hoisted_1,
    _createVNode(_component_ui_icon, { name: "camera" }),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, [
      _createVNode(_component_ui_icon, { name: "close" })
    ])
  ], 34))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    active: { default: false }
  },
  setup})